// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SwitchButtons_wrap__oPBqi","button":"SwitchButtons_button__3WFia","active":"SwitchButtons_active__1Zdvj"};